import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieBanner from "@/components/CookieBanner";

import HomePage from "@/pages/HomePage";
import TrainersPage from "@/pages/TrainersPage";
import TrainerProfilePage from "@/pages/TrainerProfilePage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import BecomeTrainerPage from "@/pages/BecomeTrainerPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import LegalPage from "@/pages/LegalPage";
import CustomerDashboard from "@/pages/CustomerDashboard";
import TrainerDashboard from "@/pages/TrainerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import AccountPage from "@/pages/AccountPage";
import NotFoundPage from "@/pages/NotFoundPage";
import MessagesPage from "@/pages/MessagesPage";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <div className="min-h-screen bg-[#FAFAFA] text-neutral-900 flex flex-col">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/trainers" element={<TrainersPage />} />
                <Route path="/trainer/:id" element={<TrainerProfilePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/become-a-trainer" element={<BecomeTrainerPage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/legal/:slug" element={<LegalPage />} />
                <Route path="/booking/success" element={<BookingSuccessPage />} />
                <Route path="/account" element={
                  <ProtectedRoute><AccountPage /></ProtectedRoute>
                } />
                <Route path="/messages" element={
                  <ProtectedRoute><MessagesPage /></ProtectedRoute>
                } />
                <Route path="/dashboard" element={
                  <ProtectedRoute roles={["customer"]}><CustomerDashboard /></ProtectedRoute>
                } />
                <Route path="/trainer" element={
                  <ProtectedRoute roles={["trainer"]}><TrainerDashboard /></ProtectedRoute>
                } />
                <Route path="/admin" element={
                  <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
                } />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster richColors position="top-right" />
            <CookieBanner />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
